import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import AssetList from "../../components/Assets/AssetList";
import AssetsFormModal from "../../components/Assets/AssetsFormModal";
import ListPagination from "../../components/Common/ListPagination";
import CommonStyles from "../../static/styles/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AssetActions from "../../store/actions/Assets";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import { isMobile } from "../../utils";

const useStyles = makeStyles((theme) => ({
  actionBar: {
    ...CommonStyles.actionBar,
    "& > button": {
      marginLeft: "20px",
    },
  },
}));

const Assets = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.ASSET_MANAGEMENT];
  console.log("All actions", allActions);

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getAssetList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getAssetList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <AssetsFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getAssetList();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <AssetViewContainer className="Assets-View container">
      <FlexContainer align="flex-start">
        <Heading>Asset Details</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.ASSET_MANAGEMENT]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="assetAddNewBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <AssetList assetList={props.assetList} handleClick={handleClick} />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </AssetViewContainer>
  );
};

const AssetViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { Asset } = state;
  console.log("Asset state", Asset);
  return {
    assetList: Asset.assetList,
    nextPage: Asset.nextPage,
    prevPage: Asset.prevPage,
    activeFilters: Asset.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAssetList: bindActionCreators(AssetActions.getAssetList, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
